/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ProvisionApplePayRequest": {
                "fields": {
                  "certificates": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "nonce": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  },
                  "nonceSignature": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "provisioningAppVersion": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "deviceType": {
                    "type": ".squareup.corporate_card.service.ProvisionApplePayRequest.DeviceType",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeviceType": {
                    "values": {
                      "DT_DO_NOT_USE": 0,
                      "UNKNOWN": 1,
                      "MOBILE_PHONE": 2,
                      "WATCH": 3
                    }
                  }
                }
              },
              "ProvisionApplePayResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.corporate_card.service.ProvisionApplePayResponse.Success",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "encryptedPassData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "activationData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ephemeralPublicKey": {
                        "type": "bytes",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ProvisionApplePayRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ProvisionApplePayRequest?.nested?.DeviceType && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ProvisionApplePayResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ProvisionApplePayResponse?.nested?.Success) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ProvisionApplePayRequest @ squareup/corporate_card/service/provision_apple_pay.proto at 10:1
 */
export const ProvisionApplePayRequest = $root.lookupType('squareup.corporate_card.service.ProvisionApplePayRequest');
fixType(ProvisionApplePayRequest, {
  cardToken: {
    required: true
  },
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(ProvisionApplePayRequest);
/**
 * The type of device initiating the provisioning request. Values must be kept in sync with squareup.bizbank.service.DeviceType.
 *
 * SOURCE DeviceType @ squareup/corporate_card/service/provision_apple_pay.proto at 12:3
 */
ProvisionApplePayRequest.DeviceType = $root.lookupEnum('squareup.corporate_card.service.ProvisionApplePayRequest.DeviceType').values;
/**
 * SOURCE ProvisionApplePayResponse @ squareup/corporate_card/service/provision_apple_pay.proto at 35:1
 */
export const ProvisionApplePayResponse = $root.lookupType('squareup.corporate_card.service.ProvisionApplePayResponse');
fixType(ProvisionApplePayResponse);
Builder.createAndAttachToType(ProvisionApplePayResponse);
/**
 * SOURCE Success @ squareup/corporate_card/service/provision_apple_pay.proto at 36:3
 */
ProvisionApplePayResponse.Success = $root.lookupType('squareup.corporate_card.service.ProvisionApplePayResponse.Success');
fixType(ProvisionApplePayResponse.Success);
Builder.createAndAttachToType(ProvisionApplePayResponse.Success);